<div class="courses">
  @if (section === 'landing' && landingData.videoCode) {
    <div class="content">
      <h1>{{ landingData.title }}</h1>
      <app-video-player [video]="landingData.videoCode" />

      <div class="description" [innerHTML]="landingData.description"></div>
    </div>
  } @else if (section === 'faq') {
    <mat-accordion class="content">
      @for (course of contentData.curriculum; track $index) {
        @if (!course.right || (course.right && showCourse(course.right))) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title [innerHTML]="course.question" />
            </mat-expansion-panel-header>
            <p [innerHTML]="course.answer"></p>
          </mat-expansion-panel>
        }
      }
    </mat-accordion>
  } @else {
    @if (loadedVideo) {
      <app-course
        [videoCode]="loadedVideo"
        [app]="section"
        [settings]="settings"
      />
    } @else {
      @for (course of contentData.curriculum; track $index) {
        @if (!course.right || (course.right && showCourse(course.right))) {
          <button
            id="video-{{ $index }}"
            type="button"
            class="course"
            (click)="showVideo(course.videoCode, $index)"
          >
            <div class="course-header">
              <h3>
                {{ course.title }}
              </h3>
            </div>
            <div class="summary" [innerHTML]="course.summary"></div>
          </button>
        }
      }
    }
  }
</div>
